<page-header
        [icon]="['QA', 'LANGUAGE'] | monIcons"
    [header]="'Language Validation Summary' | translate"
        [subHeader]="'Identify pages with incorrect or missing language tags.' | translate">
</page-header>

<!-- Warning message when language attribute is disabled -->
<div class="alert alert-warning font-size-1-3 font-weight-500 justify-content-center row" *ngIf="!isLanguageAttributeEnabled" translate>
    The setting "Use language attribute" is disabled for this domain. Please edit the domain and activate the setting to use this feature."
</div>

<!-- Main content - only show when language attribute is enabled -->
<div *ngIf="isLanguageAttributeEnabled">

<div class="row">
    <div class="col-48">
        <div class="card panel-monsido-card">
            <mon-panel-header [pHeader]="'Language tag analysis' | translate"></mon-panel-header>
            <div class="card-body">
                <mon-spinner [loading]="loading">
                    <div *ngIf="hasLanguageTagData(); else noDataTemplate">
                        <mon-chart-horizontal-bar
                            [labels]="getLanguageTagChartLabels()"
                            [data]="getLanguageTagChartData()"
                            [series]="getLanguageTagChartSeries()"
                            [options]="getLanguageTagChartOptions()"
                            [colors]="getLanguageTagChartColors()">
                        </mon-chart-horizontal-bar>
                    </div>
                    <ng-template #noDataTemplate>
                        <div class="text-center py-4">
                            <p class="text-muted">{{ 'No language tag analysis data available.' | translate }}</p>
                        </div>
                    </ng-template>
                </mon-spinner>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-48">
        <div class="card panel-monsido-card">
            <mon-panel-header [pHeader]="'Language distribution' | translate"></mon-panel-header>
            <div class="card-body">
                <mon-spinner [loading]="loading">
                    <language-match-distribution-progress-bar
                        [detectedLanguages]="summary?.detected_languages || {}"
                        [declaredLanguages]="summary?.declared_languages || {}"
                        [totalPages]="getTotalPagesCount()"
                        [totalPagesWithTags]="summary?.pages_with_tags || 0"
                    >
                    </language-match-distribution-progress-bar>
                </mon-spinner>
            </div>
        </div>
    </div>
</div>
</div> <!-- End conditional content -->
